
export const delayFetch = (fn: any, options?: { delay?: number }) => {
  if (typeof document === 'undefined') {
    const delayTime = options?.delay || 1000;

    const timerId = setTimeout(() => {
      fn?.();
      clearTimeout(timerId);
    }, delayTime);
    return
  }
  const onContentLoaded = () => {
    fn?.();
    document.removeEventListener('DOMContentLoaded', onContentLoaded);
  };

  document.addEventListener('DOMContentLoaded', function () {
    fn?.();
  });
}
